/*
Version 0.002

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2026.

!Changelog

2026
	11-04-2026
	- [ADDED] Reworked chat structure to bot rows and user rows.
	- [ADDED] Added add_bot_row method.
	- [ADDED] Added add_user_row method.
	- [ADDED] Added render_options_in_last_bot_row method.
	- [CHANGED] Answers now render inside the latest bot bubble.

!Usage
	pixelplek_chat.onready();

*/

var specific_chat = {};

(function () {

	/**
	 * Storage key for chat state
	 */
	this.storage_key = 'pixelplek_chat_state';

	/**
	 * Avatar image
	 */
	this.avatar_image = './media/images/static/smiley-3.webp';

	/**
	 * Save State
	 */
	this.save_state = function () {

		var state = {
			current_step: this.chat_flow.current_step,
			answers: this.chat_flow.answers,
			history: this.chat_flow.history
		};

		localStorage.setItem(
			this.storage_key,
			JSON.stringify(state)
		);

	};

	/**
	 * Load game
	 */
	this.load_state = function () {

		var raw_state = localStorage.getItem(this.storage_key);

		if (!raw_state) {
			return null;
		}

		try {
			return JSON.parse(raw_state);
		} catch (error) {
			return null;
		}

	};

	/**
	 * Clear
	 */
	this.clear_state = function () {

		localStorage.removeItem(this.storage_key);

	};

	// /**
	//  * Chat flow
	//  */
	// this.chat_flow = {
	// 	current_step: 'welcome',
	// 	answers: {},
	// 	history: [],
	// 	steps: {
	// 		welcome: {
	// 			message: 'Hi, leuk dat je er bent! Pixelplek wordt elke week georganiseerd op de zaterdagmiddag van 14:00 tot 18:00 uur in De Louf.',
	// 			question: 'Waar ben je nieuwsgierig naar?',
	// 			type: 'choice',
	// 			field: 'entry_point',
	// 			options: [
	// 				{
	// 					label: 'Ik wil iets maken',
	// 					reply: 'Mooi. Pixelplek is juist bedoeld voor mensen die zelf dingen willen maken en uitproberen.',
	// 					next: 'make'
	// 				},
	// 				{
	// 					label: 'Ik wil experimenteren',
	// 					reply: 'Top. Dan kunnen we kijken waar je zin in hebt om mee te spelen.',
	// 					next: 'experiment',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Ik zoek ideeën',
	// 					reply: 'Lekker. Dan gaan we even kijken welke digitale projecten bij je passen.',
	// 					next: 'ideas'
	// 				},
	// 				{
	// 					label: 'Ik wil iets nieuws proberen',
	// 					reply: 'Goed begin. Je hoeft nog niet precies te weten wat.',
	// 					next: 'new_things',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Ik kijk gewoon even rond',
	// 					reply: 'Prima. Dan laat ik je rustig zien waar Pixelplek over gaat.',
	// 					next: 'browse',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		make: {
	// 			question: 'Wat lijkt je leuk om te maken?',
	// 			type: 'choice',
	// 			field: 'make_type',
	// 			options: [
	// 				{
	// 					label: 'Muziek',
	// 					reply: 'Nice. Muziek maken op de computer past hier heel goed.',
	// 					next: 'music'
	// 				},
	// 				{
	// 					label: 'Een website',
	// 					reply: 'Top. Websites bouwen hoort hier helemaal thuis.',
	// 					next: 'website'
	// 				},
	// 				{
	// 					label: 'Iets met AI of vibecoden',
	// 					reply: 'Ja, daar kun je hier ook mee aan de slag.',
	// 					next: 'ai',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Iets anders',
	// 					reply: 'Ook goed. Het hoeft niet in een hokje te passen.',
	// 					next: 'other_project'
	// 				}
	// 			]
	// 		},

	// 		experiment: {
	// 			question: 'Waar wil je mee experimenteren?',
	// 			type: 'choice',
	// 			field: 'experiment_type',
	// 			options: [
	// 				{
	// 					label: 'Code',
	// 					reply: 'Goed. Met code kun je veel kanten op.',
	// 					next: 'code'
	// 				},
	// 				{
	// 					label: 'Beeld / video',
	// 					reply: 'Mooi. Daar kun je hier ook goed mee spelen.',
	// 					next: 'visual'
	// 				},
	// 				{
	// 					label: 'Muziek / geluid',
	// 					reply: 'Leuk. Dat is ook een mooie ingang.',
	// 					next: 'music'
	// 				},
	// 				{
	// 					label: 'Ik weet het nog niet',
	// 					reply: 'Geeft niks. Dan zoeken we samen een ingang.',
	// 					next: 'help_choose',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		ideas: {
	// 			question: 'Waar wil je ideeën voor opdoen?',
	// 			type: 'choice',
	// 			field: 'ideas_type',
	// 			options: [
	// 				{
	// 					label: 'Projecten',
	// 					reply: 'Top. Dan kijken we naar dingen die je zelf kunt bouwen of maken.',
	// 					next: 'project_ideas'
	// 				},
	// 				{
	// 					label: 'Tools',
	// 					reply: 'Goed. Er zijn veel leuke tools om mee te hobbyen.',
	// 					next: 'tool_ideas'
	// 				},
	// 				{
	// 					label: 'Creatieve richtingen',
	// 					reply: 'Mooi. Dan kunnen we breder kijken naar wat bij je past.',
	// 					next: 'creative_directions',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		new_things: {
	// 			question: 'Wat zou je graag eens willen proberen?',
	// 			type: 'choice',
	// 			field: 'new_type',
	// 			options: [
	// 				{
	// 					label: 'Zelf iets bouwen',
	// 					reply: 'Ja, dat is precies de sfeer van Pixelplek.',
	// 					next: 'make'
	// 				},
	// 				{
	// 					label: 'Nieuwe software ontdekken',
	// 					reply: 'Goed idee. Er zijn genoeg leuke tools om uit te proberen.',
	// 					next: 'tool_ideas',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Samen hobbyen met anderen',
	// 					reply: 'Dat is ook precies het leuke eraan.',
	// 					next: 'about_pixelplek',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		browse: {
	// 			message: 'Pixelplek is een computerclub voor mensen die willen hobbyen met de computer en aan hun eigen projecten willen werken.',
	// 			question: 'Wat wil je als eerste weten?',
	// 			type: 'choice',
	// 			field: 'browse_type',
	// 			options: [
	// 				{
	// 					label: 'Wat je er kunt maken',
	// 					reply: 'Van muziek tot websites en van code tot AI-experimenten.',
	// 					next: 'project_ideas',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Hoe het werkt',
	// 					reply: 'Dan laat ik je zien hoe Pixelplek in elkaar zit.',
	// 					next: 'how_it_works'
	// 				},
	// 				{
	// 					label: 'Of het bij mij past',
	// 					reply: 'Goed. Dan kijken we daarnaar.',
	// 					next: 'fit'
	// 				}
	// 			]
	// 		},

	// 		project_ideas: {
	// 			message: 'Je kunt denken aan muziek maken, websites bouwen, creatieve codeprojecten, AI-tools uitproberen of gewoon lekker digitaal knutselen.',
	// 			question: 'Wat spreekt je het meest aan?',
	// 			type: 'choice',
	// 			field: 'project_interest',
	// 			options: [
	// 				{
	// 					label: 'Muziek',
	// 					reply: 'Mooi. Dat is een goede ingang.',
	// 					next: 'music'
	// 				},
	// 				{
	// 					label: 'Websites',
	// 					reply: 'Top. Dan zit je hier goed.',
	// 					next: 'website'
	// 				},
	// 				{
	// 					label: 'AI / vibecoden',
	// 					reply: 'Ja, daar kun je hier ook mee experimenteren.',
	// 					next: 'ai',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Vrij experimenteren',
	// 					reply: 'Ook goed. Niet alles hoeft vooraf vast te liggen.',
	// 					next: 'free_play',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		how_it_works: {
	// 			message: 'Je kunt bij Pixelplek werken aan je eigen project, dingen uitproberen en samen hobbyen met andere mensen die ook graag met digitale dingen bezig zijn.',
	// 			question: 'Wat wil je hierna doen?',
	// 			type: 'choice',
	// 			field: 'how_type',
	// 			options: [
	// 				{
	// 					label: 'Nog meer ontdekken',
	// 					reply: 'Prima, we gaan verder.',
	// 					next: 'project_ideas'
	// 				},
	// 				{
	// 					label: 'Kijken of het bij mij past',
	// 					reply: 'Goed. Dan gaan we daarop in.',
	// 					next: 'fit',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Meedoen',
	// 					reply: 'Mooi. Dan pakken we dat.',
	// 					next: 'join'
	// 				}
	// 			]
	// 		},

	// 		music: {
	// 			message: 'Met muziek kun je denken aan beats maken, geluiden bewerken, tracks bouwen of gewoon spelen met software.',
	// 			question: 'Wil je verder kijken?',
	// 			type: 'choice',
	// 			field: 'music_type',
	// 			options: [
	// 				{
	// 					label: 'Ja, laat meer zien',
	// 					reply: 'Top.',
	// 					next: 'join',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Iets anders kiezen',
	// 					reply: 'Ook goed.',
	// 					next: 'project_ideas'
	// 				}
	// 			]
	// 		},

	// 		website: {
	// 			message: 'Bij websites kun je denken aan pagina’s bouwen, design uitproberen, code schrijven en je eigen ideeën online zetten.',
	// 			question: 'Wat wil je doen?',
	// 			type: 'choice',
	// 			field: 'website_type',
	// 			options: [
	// 				{
	// 					label: 'Meer hierover',
	// 					reply: 'Top.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Nog iets anders bekijken',
	// 					reply: 'Prima.',
	// 					next: 'project_ideas',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		ai: {
	// 			message: 'Je kunt ook experimenteren met AI, tools, prompts en vibecoden om dingen te maken die eerst alleen een idee waren.',
	// 			question: 'Wil je hiermee verder?',
	// 			type: 'choice',
	// 			field: 'ai_type',
	// 			options: [
	// 				{
	// 					label: 'Ja',
	// 					reply: 'Mooi.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Nee, iets anders',
	// 					reply: 'Prima.',
	// 					next: 'project_ideas'
	// 				}
	// 			]
	// 		},

	// 		code: {
	// 			message: 'Code is een mooie ingang als je dingen wilt bouwen, testen en aanpassen.',
	// 			question: 'Wat wil je nu doen?',
	// 			type: 'choice',
	// 			field: 'code_type',
	// 			options: [
	// 				{
	// 					label: 'Verder kijken',
	// 					reply: 'Goed.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Terug naar projecten',
	// 					reply: 'Prima.',
	// 					next: 'project_ideas',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		visual: {
	// 			message: 'Ook met beeld, video en visuele experimenten kun je hier goed uit de voeten.',
	// 			question: 'Wat wil je nu doen?',
	// 			type: 'choice',
	// 			field: 'visual_type',
	// 			options: [
	// 				{
	// 					label: 'Verder kijken',
	// 					reply: 'Top.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Iets anders bekijken',
	// 					reply: 'Prima.',
	// 					next: 'project_ideas',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		tool_ideas: {
	// 			message: 'Soms begint het gewoon met een tool ontdekken en dan kijken wat je ermee kunt maken.',
	// 			question: 'Wat wil je nu doen?',
	// 			type: 'choice',
	// 			field: 'tool_type',
	// 			options: [
	// 				{
	// 					label: 'Verder kijken',
	// 					reply: 'Goed.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Andere richting',
	// 					reply: 'Prima.',
	// 					next: 'project_ideas'
	// 				}
	// 			]
	// 		},

	// 		creative_directions: {
	// 			message: 'Je hoeft niet meteen een doel te hebben. Soms is het genoeg om iets te proberen en te kijken waar het heen gaat.',
	// 			question: 'Wat past het best bij jou?',
	// 			type: 'choice',
	// 			field: 'creative_type',
	// 			options: [
	// 				{
	// 					label: 'Vrij proberen',
	// 					reply: 'Mooi.',
	// 					next: 'free_play'
	// 				},
	// 				{
	// 					label: 'Toch iets concreets',
	// 					reply: 'Top.',
	// 					next: 'project_ideas',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		free_play: {
	// 			message: 'Dat vrije uitproberen hoort er juist bij. Niet alles hoeft meteen handig of af te zijn.',
	// 			question: 'Wil je weten hoe je kunt meedoen?',
	// 			type: 'choice',
	// 			field: 'free_play_type',
	// 			options: [
	// 				{
	// 					label: 'Ja',
	// 					reply: 'Top.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Nog even verder kijken',
	// 					reply: 'Prima.',
	// 					next: 'browse',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		help_choose: {
	// 			message: 'Je hoeft nog niet precies te weten waar je moet beginnen. Dat zoeken hoort er ook bij.',
	// 			question: 'Waar wil je naartoe?',
	// 			type: 'choice',
	// 			field: 'help_choose_type',
	// 			options: [
	// 				{
	// 					label: 'Projectideeën',
	// 					reply: 'Goed.',
	// 					next: 'project_ideas'
	// 				},
	// 				{
	// 					label: 'Wat Pixelplek is',
	// 					reply: 'Prima.',
	// 					next: 'browse',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		fit: {
	// 			message: 'Als je graag hobbyt met de computer, dingen wilt uitproberen en zelf projecten wilt maken, dan past Pixelplek waarschijnlijk goed.',
	// 			question: 'Wat wil je nu doen?',
	// 			type: 'choice',
	// 			field: 'fit_type',
	// 			options: [
	// 				{
	// 					label: 'Meedoen',
	// 					reply: 'Top.',
	// 					next: 'join'
	// 				},
	// 				{
	// 					label: 'Nog iets bekijken',
	// 					reply: 'Prima.',
	// 					next: 'browse',
	// 					// wide: true
	// 				}
	// 			]
	// 		},

	// 		join: {
	// 			message: 'Lijkt het je wat? Dan kunnen we hier straks een knop of CTA aan hangen voor meer info of aanmelden.',
	// 			question: 'Wat wil je nu doen?',
	// 			type: 'choice',
	// 			field: 'join_type',
	// 			options: [
	// 				{
	// 					label: 'Opnieuw beginnen',
	// 					reply: 'Helemaal goed, we starten opnieuw.',
	// 					next: 'restart',
	// 					// wide: true
	// 				},
	// 				{
	// 					label: 'Nog even rondkijken',
	// 					reply: 'Prima.',
	// 					next: 'browse',
	// 					// wide: true
	// 				}
	// 			]
	// 		}
	// 	}
	// };

	/**
 * Chat flow
 */
	this.chat_flow = {
		current_step: 'welcome',
		answers: {},
		history: [],
		steps: {
			welcome: {
				message: 'Hi, leuk dat je er bent! Pixelplek is een plek waar mensen samenkomen om te hobbyen met de computer. Elke zaterdagmiddag van 14:00 tot 18:00 uur in De Louf.',
				question: 'Waar ben je benieuwd naar?',
				type: 'choice',
				field: 'entry_point',
				options: [
					{
						label: 'Wat je er kunt doen',
						reply: 'Top. Dan laat ik je zien wat voor dingen je hier kunt maken en uitproberen.',
						next: 'what_you_can_do_2'
					},
					{
						label: 'Of het bij mij past',
						reply: 'Goed. Dan kijken we even of Pixelplek iets voor jou is.',
						next: 'fit'
					},
					{
						label: 'Hoe het werkt',
						reply: 'Prima. Dan leg ik kort uit hoe Pixelplek in elkaar zit.',
						next: 'how_it_works'
					}
				]
			},

			what_you_can_do: {
				message: 'Bij Pixelplek werk je zelfstandig aan je eigen computerprojecten. Denk aan muziek maken, websites bouwen, programmeren, video’s editten, fotografie, computerkunst, AI-tools gebruiken of gewoon lekker digitaal experimenteren.',
				question: 'Wat spreekt je het meest aan?',
				type: 'choice',
				field: 'interest_type',
				options: [
					{
						label: 'Muziek maken',
						reply: 'Mooi. Muziek maken op de computer past hier heel goed.',
						next: 'music'
					},
					{
						label: 'Websites / programmeren',
						reply: 'Top. Ook websites bouwen en code schrijven passen hier helemaal bij.',
						next: 'code'
					},
					{
						label: 'AI / tools / vibecoden',
						reply: 'Ja, daar kun je hier ook volop mee experimenteren.',
						next: 'ai'
					},
					{
						label: 'Video / fotografie / beeld',
						reply: 'Leuk. Ook beeld, video en visuele projecten passen goed binnen Pixelplek.',
						next: 'visual'
					},
					{
						label: 'Gewoon experimenteren',
						reply: 'Ook goed. Niet alles hoeft vooraf vast te liggen.',
						next: 'free_play'
					},
					{
						label: 'Ik weet het nog niet',
						reply: 'Geeft niks. Je hoeft nog niet precies te weten wat je wilt doen.',
						next: 'dont_know_yet'
					}
				]
			},

			what_you_can_do_2: {
				message: 'Zaterdagmiddag 14:00 - 18:00 uur in De Louf - Hoefseweg 5. Vrije inloop, geen aanmelding nodig. Je kan langskomen met je eigen laptop, robot, 3D printer of gewoon je nieuwsgierigheid. Je werkt aan je eigen projecten, maar je bent wel in een ruimte met anderen die ook graag maken, proberen en ontdekken.',
				question: 'Wat vind je leuk om te doen?',
				type: 'choice',
				field: 'interest_type',
				options: [
					{
						label: 'Muziek maken',
						reply: 'Mooi. Muziek maken op de computer past hier heel goed.',
						next: 'music'
					},
					{
						label: 'Websites / programmeren',
						reply: 'Top. Ook websites bouwen en code schrijven passen hier helemaal bij.',
						next: 'code'
					},
					{
						label: 'AI / tools / vibecoden',
						reply: 'Ja, daar kun je hier ook volop mee experimenteren.',
						next: 'ai'
					},
					{
						label: 'Video / fotografie / beeld',
						reply: 'Leuk. Ook beeld, video en visuele projecten passen goed binnen Pixelplek.',
						next: 'visual'
					},
					{
						label: 'Gewoon experimenteren',
						reply: 'Ook goed. Niet alles hoeft vooraf vast te liggen.',
						next: 'free_play'
					},
					{
						label: 'Ik weet het nog niet',
						reply: 'Geeft niks. Je hoeft nog niet precies te weten wat je wilt doen.',
						next: 'dont_know_yet'
					}
				]
			},

			how_it_works: {
				message: 'Je komt gewoon langs met je laptop (of tablet of smartphone) en je idee, kiest waar je zin in hebt en gaat aan de slag. Je werkt zelfstandig, maar je bent wel in een ruimte met anderen die ook graag maken, proberen en ontdekken.',
				question: 'Wat wil je nu weten?',
				type: 'choice',
				field: 'how_it_works_type',
				options: [
					{
						label: 'Wat je er kunt doen',
						reply: 'Top, dan laat ik je zien welke kanten je op kunt.',
						next: 'what_you_can_do'
					},
					{
						label: 'Of het bij mij past',
						reply: 'Goed, daar kunnen we ook even naar kijken.',
						next: 'fit'
					},
					{
						label: 'Klinkt goed',
						reply: 'Mooi.',
						next: 'cta'
					}
				]
			},

			fit: {
				message: 'Als je graag dingen maakt op de computer (of tablet of smartphone), zelfstandig aan projecten wilt werken en het leuk vindt om te experimenteren, dan past Pixelplek waarschijnlijk goed bij je. Je hoeft niet “goed” te zijn of al precies te weten wat je wilt maken.',
				question: 'Hoe klinkt dat voor jou?',
				type: 'choice',
				field: 'fit_type',
				options: [
					{
						label: 'Dat past wel bij mij',
						reply: 'Top. Dan is de kans groot dat je je hier snel thuis voelt.',
						next: 'cta'
					},
					{
						label: 'Ik twijfel nog een beetje',
						reply: 'Prima. Dan laat ik je nog even zien wat je er allemaal kunt doen.',
						next: 'what_you_can_do_2'
					},
					{
						label: 'Ik wil eerst snappen hoe het werkt',
						reply: 'Helemaal goed.',
						next: 'how_it_works'
					}
				]
			},

			music: {
				message: 'Bij muziek kun je denken aan beats maken, sounds bouwen, tracks opzetten of gewoon spelen met software en ideeën.',
				question: 'Zou je dit zelf wel eens willen proberen?',
				type: 'choice',
				field: 'music_type',
				options: [
					{
						label: 'Ja, lijkt me leuk',
						reply: 'Mooi. Daar is Pixelplek een goede plek voor.',
						next: 'cta'
					},
					{
						label: 'Misschien iets anders',
						reply: 'Prima. Dan kijken we nog even verder.',
						next: 'what_you_can_do'
					}
				]
			},

			code: {
				message: 'Bij websites en programmeren kun je denken aan pagina’s bouwen, code schrijven, dingen testen en je eigen ideeën online of digitaal vormgeven.',
				question: 'Spreekt dat je aan?',
				type: 'choice',
				field: 'code_type',
				options: [
					{
						label: 'Ja, zeker',
						reply: 'Top. Dan past dat goed binnen Pixelplek.',
						next: 'cta'
					},
					{
						label: 'Ik wil nog meer opties zien',
						reply: 'Goed, dan kijken we nog even verder.',
						next: 'what_you_can_do_2'
					}
				]
			},

			ai: {
				message: 'Je kunt ook werken met AI, tools, prompts en vibecoden om nieuwe dingen te maken en uit te proberen.',
				question: 'Lijkt dat je interessant?',
				type: 'choice',
				field: 'ai_type',
				options: [
					{
						label: 'Ja, dat spreekt me aan',
						reply: 'Mooi. Ook daar kun je bij Pixelplek mee aan de slag.',
						next: 'cta'
					},
					{
						label: 'Ik wil nog iets anders zien',
						reply: 'Prima.',
						next: 'what_you_can_do'
					}
				]
			},

			visual: {
				message: 'Met beeld kun je denken aan video’s editten, fotografie, digitale beelden maken of experimenteren met visuele ideeën.',
				question: 'Is dat meer jouw richting?',
				type: 'choice',
				field: 'visual_type',
				options: [
					{
						label: 'Ja, dat lijkt me tof',
						reply: 'Leuk. Ook dat past goed binnen Pixelplek.',
						next: 'cta'
					},
					{
						label: 'Ik wil nog verder kijken',
						reply: 'Ook goed.',
						next: 'what_you_can_do_2'
					}
				]
			},

			free_play: {
				message: 'Dat vrije experimenteren hoort er juist bij. Niet alles hoeft meteen handig, slim of af te zijn. Soms begint het gewoon met iets proberen.',
				question: 'Klinkt dat goed?',
				type: 'choice',
				field: 'free_play_type',
				options: [
					{
						label: 'Ja, dat past bij mij',
						reply: 'Top.',
						next: 'cta'
					},
					{
						label: 'Ik wil nog wat voorbeelden zien',
						reply: 'Prima.',
						next: 'what_you_can_do'
					}
				]
			},

			dont_know_yet: {
				message: 'Geen probleem. Je hoeft nog niet precies te weten wat je wilt doen. Pixelplek is juist ook bedoeld om dingen te ontdekken en uit te proberen.',
				question: 'Wat wil je nu?',
				type: 'choice',
				field: 'dont_know_yet_type',
				options: [
					{
						label: 'Voorbeelden zien',
						reply: 'Top, dan kijken we daar nog even naar.',
						next: 'what_you_can_do_2'
					},
					{
						label: 'Kijken of het bij mij past',
						reply: 'Goed.',
						next: 'fit'
					},
					{
						label: 'Klinkt eigenlijk al goed',
						reply: 'Mooi.',
						next: 'cta'
					}
				]
			},

			cta: {
				message: 'Pixelplek is elke zaterdagmiddag van 14:00 tot 18:00 uur in De Louf. Je kunt gewoon langskomen en aanhaken.',
				question: 'Wat wil je nu doen?',
				type: 'choice',
				field: 'cta_type',
				options: [
					{
						label: 'Ik kom graag een keer langs',
						reply: 'Leuk. Kom gewoon langs aanstaande zaterdag.',
						next: 'done'
					},
					{
						label: 'Ik wil nog even verder kijken',
						reply: 'Prima. Kijk rustig nog even rond.',
						next: 'what_you_can_do'
					},
					{
						label: 'Ik wil eerst weten of het bij mij past',
						reply: 'Helemaal goed.',
						next: 'fit'
					}
				]
			},

			done: {
				message: 'Top. Dan zien we je hopelijk zaterdag. Neem gerust je laptop, ideeën of gewoon je nieuwsgierigheid mee.',
				question: 'Wil je nog iets doen?',
				type: 'choice',
				field: 'done_type',
				options: [
					{
						label: 'Opnieuw beginnen',
						reply: 'Helemaal goed, we starten opnieuw.',
						next: 'restart'
					},
					{
						label: 'Nog even rondkijken',
						reply: 'Prima.',
						next: 'what_you_can_do_2'
					}
				]
			}
		}
	};

	/**
	 * On ready
	 */
	this.onready = function () {

		var _this = this;

		$(document)
			.off('click', '.js-chat-option')
			.on(
				'click',
				'.js-chat-option',
				function () {

					var step_key = $(this).attr('data-step');
					var option_index = parseInt($(this).attr('data-option-index'), 10);

					_this.handle_answer(
						step_key,
						option_index
					);

				}
			);

		$(document)
			.off('click', '.js-chat-restart')
			.on(
				'click',
				'.js-chat-restart',
				function () {
					_this.reset_chat();
				}
			);

		this.init();

	};

	/**
	 * Init
	 */
	this.init = function () {

		var saved_state = this.load_state();

		$('.js-chatbox-messages').html('');

		if (
			saved_state !== null &&
			typeof saved_state.current_step != 'undefined'
		) {
			this.chat_flow.current_step = saved_state.current_step || 'welcome';
			this.chat_flow.answers = saved_state.answers || {};
			this.chat_flow.history = saved_state.history || [];

			this.rebuild_chat(true);

			return;
		}

		this.chat_flow.current_step = 'welcome';
		this.chat_flow.answers = {};
		this.chat_flow.history = [];

		this.render_step(
			this.chat_flow.current_step
		);

	};

	/**
	 * Rebuild chat from state
	 */
	this.rebuild_chat = function (show_return_message) {

		var history = this.chat_flow.history;
		var i = 0;
		var step_key = '';
		var step = null;
		var answer_label = '';
		var option = null;

		$('.js-chatbox-messages').html('');

		for (i = 0; i < history.length; i++) {

			step_key = history[i];
			step = this.chat_flow.steps[step_key];

			if (typeof step == 'undefined') {
				continue;
			}

			answer_label = this.chat_flow.answers[step.field];

			var $row = this.add_bot_row(
				step.message || '',
				step.question || ''
			);

			// var $bubble = $row.find('.chat__bubble--bot');

			// // 👉 BELANGRIJK: forceer spacing terug voor history
			// $bubble.removeClass('is-no-options');

			this.add_user_row(
				answer_label
			);

			option = this.find_option_by_label(
				step,
				answer_label
			);

			if (
				option &&
				typeof option.reply != 'undefined' &&
				option.reply != ''
			) {
				var $reply_row = this.add_bot_row(option.reply, '', true); // true = isReply
				var $reply_bubble = $reply_row.find('.chat__bubble--bot');

				$reply_bubble.removeClass('is-no-options');
			}

		}

		if (show_return_message === true) {
			this.add_bot_row(
				'Leuk dat je er weer bent. We gaan verder waar je gebleven was.',
				''
			);
		}

		this.render_step(
			this.chat_flow.current_step
		);

	};

	/**
	 * Find option
	 */
	this.find_option_by_label = function (step, label) {

		var i = 0;

		if (
			typeof step == 'undefined' ||
			typeof step.options == 'undefined'
		) {
			return null;
		}

		for (i = 0; i < step.options.length; i++) {
			if (step.options[i].label == label) {
				return step.options[i];
			}
		}

		return null;

	};

	/**
	 * Render step
	 */
	this.render_step = function (step_key) {

		var step = this.chat_flow.steps[step_key];
		var $row = null;

		if (typeof step == 'undefined') {
			return;
		}

		if (step_key == 'restart') {
			this.reset_chat();
			return;
		}

		$row = this.add_bot_row(
			step.message || '',
			step.question || ''
		);

		this.render_options_in_last_bot_row(
			step_key,
			step,
			$row
		);

	};

	/**
	 * Add bot row
	 */
	this.add_bot_row = function (message, question, isReply) {

		var html = '';
		var $row = null;
		var $bubble = null;

		// isReply is optional parameter to indicate if this is a bot reply
		isReply = isReply || false;

		html += '<div class="chat__row chat__row--bot">';
		html += '	<div class="chat__avatar">';
		html += '		<img src="' + this.escape_html(this.avatar_image) + '" alt="Pixelplek avatar">';
		html += '	</div>';
		html += '	<div class="chat__bubble chat__bubble--bot">';

		if (message != '') {
			html += '		<p class="message">' + this.escape_html(message).replace(/\n/g, '<br>') + '</p>';
		}

		if (question != '') {
			html += '		<p class="question">' + this.escape_html(question).replace(/\n/g, '<br>') + '</p>';
		}

		html += '		<div class="js-chatbox-answers-inner"></div>';
		html += '	</div>';
		html += '</div>';

		$('.js-chatbox-messages').append(html);

		$row = $('.js-chatbox-messages .chat__row--bot').last();
		$bubble = $row.find('.chat__bubble--bot');

		if (message == '') {
			$bubble.addClass('is-no-message');
		}

		if (question == '') {
			$bubble.addClass('is-no-question');
		}

		// Use different scroll behavior for bot replies vs initial questions
		if (isReply && message != '') {
			// For bot replies, scroll to the top of the new content
			this.scroll_to_new_content($row);
		} else {
			// For initial questions and other content, use normal scroll
			this.scroll_to_new_content();
		}

		return $row;

	};

	/**
	 * Add user row
	 */
	this.add_user_row = function (message) {

		var html = '';

		html += '<div class="chat__row chat__row--user">';
		html += '	<div class="chat__bubble chat__bubble--user">';
		html += '		<p>' + this.escape_html(message).replace(/\n/g, '<br>') + '</p>';
		html += '	</div>';
		html += '</div>';

		$('.js-chatbox-messages').append(html);

		this.scroll_to_new_content();

	};

	/**
	 * Render options in last bot row
	 */
	this.render_options_in_last_bot_row = function (step_key, step, $row) {

		var html = '';
		var i = 0;
		var option = null;
		var option_class = '';
		var $target = null;
		var $bubble = null;

		if (typeof $row == 'undefined' || !$row.length) {
			return;
		}

		$target = $row.find('.js-chatbox-answers-inner');
		$bubble = $row.find('.chat__bubble--bot');

		if (step.type == 'choice') {

			html += '<div class="options">';

			for (i = 0; i < step.options.length; i++) {

				option = step.options[i];
				option_class = 'option js-chat-option';

				if (
					typeof option.wide != 'undefined' &&
					option.wide == true
				) {
					option_class += ' option--wide';
				}

				html += '<button ';
				html += 'type="button" ';
				html += 'class="' + option_class + '" ';
				html += 'data-step="' + step_key + '" ';
				html += 'data-option-index="' + i + '">';
				html += this.escape_html(option.label);
				html += '</button>';

			}

			html += '</div>';

		}

		if (this.chat_flow.history.length > 0) {
			html += '<div class="chatbox__actions">';
			html += '<button type="button" class="chatbox__button chatbox__button--ghost js-chat-restart">Opnieuw beginnen</button>';
			html += '</div>';
		}

		$target.html(html);

		if ($.trim($target.html()) == '') {
			$bubble.addClass('is-no-options');
		} else {
			$bubble.removeClass('is-no-options');
		}

		this.scroll_to_new_content();

	};

	/**
	 * Disable options in a row
	 */
	this.disable_options_in_row = function ($row, selected_index) {

		var $buttons = null;

		if (typeof $row == 'undefined' || !$row.length) {
			return;
		}

		$buttons = $row.find('.js-chat-option');

		$buttons.prop('disabled', true);

		$buttons.each(function (index) {

			$(this).addClass('is-disabled');

			if (index == selected_index) {
				$(this).addClass('is-active');
			}

		});

	};

	/**
	 * Handle answer
	 */
	this.handle_answer = function (step_key, option_index) {

		var _this = this;
		var step = this.chat_flow.steps[step_key];
		var option = null;
		var next_step = '';
		var $last_bot_row = $('.js-chatbox-messages .chat__row--bot').last();

		if (
			typeof step == 'undefined' ||
			typeof step.options == 'undefined' ||
			typeof step.options[option_index] == 'undefined'
		) {
			return;
		}

		option = step.options[option_index];
		next_step = option.next;

		if (typeof step.field != 'undefined') {
			this.chat_flow.answers[step.field] = option.label;
		}

		this.chat_flow.history.push(step_key);

		if (
			typeof next_step != 'undefined' &&
			next_step != ''
		) {
			this.chat_flow.current_step = next_step;
		}

		this.save_state();

		this.disable_options_in_row(
			$last_bot_row,
			option_index
		);

		this.add_user_row(option.label);

		if (
			typeof option.reply != 'undefined' &&
			option.reply != ''
		) {
			setTimeout(function () {
				_this.add_bot_row(option.reply, '', true); // true = isReply
			}, 250);
		}

		if (
			typeof next_step != 'undefined' &&
			next_step != ''
		) {
			setTimeout(function () {

				_this.chat_flow.current_step = next_step;

				_this.render_step(
					next_step
				);

			}, 700);
		}

	};

	/**
	 * Reset chat
	 */
	this.reset_chat = function () {

		this.clear_state();

		$('.js-chatbox-messages').html('');

		this.chat_flow.current_step = 'welcome';
		this.chat_flow.answers = {};
		this.chat_flow.history = [];

		this.render_step(
			this.chat_flow.current_step
		);

	};

	/**
	 * Escape HTML
	 */
	this.escape_html = function (string) {

		if (typeof string != 'string') {
			string = String(string);
		}

		return string
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');

	};

	/**
	 * Scroll to bottom
	 */
	this.scroll_to_bottom = function () {

		var $messages = $('.js-chatbox-messages');
		var $lastRow = $messages.find('.chat__row').last();

		if ($messages.length == 0 || $lastRow.length == 0) {
			return;
		}

		// Scroll to the top of the last message with some offset for better mobile experience
		var targetScrollTop = $lastRow.offset().top - 60; // 60px offset from top

		// Make sure we don't scroll above the page
		targetScrollTop = Math.max(0, targetScrollTop);

		$('html, body').stop().animate(
			{
				scrollTop: targetScrollTop
			},
			500
		);

	};

	/**
	 * Scroll to new bot content (for replies)
	 */
	this.scroll_to_new_content = function ($newRow) {

		if (!$newRow || $newRow.length == 0) {
			return;
		}

		// For bot replies, find the last user answer for context
		var $userRows = $('.js-chatbox-messages .chat__row--user');
		var $lastUserRow = $userRows.last();

		// If we have a user row, scroll to show both user answer and bot reply
		if ($lastUserRow.length > 0) {
			targetScrollTop = $lastUserRow.offset().top - 40; // Show user answer with small offset
		} else {
			// Fallback: scroll to the bot row
			targetScrollTop = $newRow.offset().top - 80;
		}

		console.log(targetScrollTop);

		// Make sure we don't scroll above the page
		targetScrollTop = Math.max(0, targetScrollTop);

		$('html, body').stop().animate(
			{
				scrollTop: targetScrollTop
			},
			500
		);

	};
}).apply(specific_chat);